package de.oevbs.kunde.kundenportal2.model.services.registration

import de.oevbs.kunde.kundenportal2.ResetStep
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class Reset(
    val userOrPartner: String = "",   // Benutzereingabe
    val username: String = "",        // Eingeloggter Username, darf nicht in neuem Pass enthalten sein
    val token: String = "",
    val newPassword: String = "",
    val newPasswordRepeat: String = "",
) {
    companion object {
        val validation = validation<Reset, ResetStep, ComponentValidationMessage> { inspector, step ->
            when (step) {

                ResetStep.USERINPUT1 -> {
                    val user = inspector.map(Reset.userOrPartner())
                    if (user.data.isEmpty()) {
                        add(user.errorMessage(KupoValidationMessages.EMPTY_INPUT))
                    } else {
                        val intOrNull = user.data.first().digitToIntOrNull()
                        if ((intOrNull != null && !Regexes.partnerId.matches(user.data))) {
                            add(user.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                        } else if ((intOrNull == null && !Regexes.userName.matches(user.data))) {
                            add(user.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                        }
                    }
                }

                ResetStep.PASSWORD3 -> {
                    val pass = inspector.map(Reset.newPassword())
                    if (pass.data.isEmpty()) {
                        add(pass.errorMessage("Bitte geben Sie ein Passwort ein."))
                    } else if (!Regexes.password.matches(pass.data)) {
                        add(pass.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                    } else {
                        val user = inspector.map(Reset.username())
                        if (user.data.isNotEmpty() && pass.data.contains(user.data)) {
                            add(user.errorMessage("Ihr Passwort darf nicht Ihren Benutzer oder Partner enthalten."))
                        }
                    }

                    val passRepeat = inspector.map(Reset.newPasswordRepeat())
                    if (passRepeat.data.isEmpty()) {
                        add(passRepeat.errorMessage("Bitte wiederholen Sie Ihr neues Passwort."))
                    } else if (passRepeat.data != pass.data) {
                        add(passRepeat.errorMessage("Die Passwörter stimmen nicht überein."))
                    }
                }

                else -> println("Fehler - Unbekannter Reset Step im ResetValidator.")
            }
        }
    }
}